export default {
    brand_delete_title: "Eliminar marca",
    brand_delete_success_message: "Se ha eliminado la marca",
    brand_delete_message: "¿Estás seguro de que quieres eliminar la marca?",
    brand_delete_general_error: "No ha sido posible eliminar la marca debido a un error",
    brand_delete_package_in_use_dealer: "La marca está vinculada a algunos distribuidores, por lo que no es posible eliminarlo",
}